import { useState } from "react";
import { NavLink } from "react-router-dom";

const tabs = [
  { label: "首页", to: "/", icon: "ri-home-5-line", end: true },
  { label: "搜索", to: "/search", icon: "ri-search-line", end: false },
  { label: "分类", to: "/category/films", icon: "ri-layout-grid-line", end: false },
];

export default function MobileTabBar() {
  const [toast, setToast] = useState("");

  const showToast = () => {
    setToast("收藏功能正在开发中，敬请期待");
    window.setTimeout(() => setToast(""), 2000);
  };

  return (
    <>
      {toast && (
        <div className="fixed bottom-20 left-1/2 z-50 -translate-x-1/2 rounded-full bg-foreground-900 px-4 py-2 text-xs text-background-50 md:hidden">
          {toast}
        </div>
      )}
      <nav className="fixed bottom-0 left-0 right-0 z-40 flex h-16 items-center justify-around border-t border-background-200 bg-background-50/95 backdrop-blur md:hidden">
        {tabs.map((tab) => (
          <NavLink
            key={tab.label}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) =>
              `flex w-full flex-col items-center justify-center gap-1 text-[11px] transition-colors ${
                isActive ? "text-primary-600" : "text-foreground-500"
              }`
            }
          >
            <i className={`${tab.icon} text-lg`} aria-hidden="true"></i>
            {tab.label}
          </NavLink>
        ))}
        <button
          type="button"
          onClick={showToast}
          className="flex w-full flex-col items-center justify-center gap-1 text-[11px] text-foreground-500 cursor-pointer"
        >
          <i className="ri-user-star-line text-lg" aria-hidden="true"></i>
          我的
        </button>
      </nav>
    </>
  );
}